<template>
  <v-container fluid class="pa-0">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <ContactUsBanner />
    <ContactUsForm />


  </v-container>
</template>

<script>
import ContactUsBanner from "@/components/ContactUs/ContactUsBanner.vue";
import ContactUsForm from "@/components/ContactUs/ContactUsForm.vue";

export default {
  name: "Contactus",
  components: { ContactUsBanner, ContactUsForm },
  data() {
    return { isLoading: false };
  },
};
</script>

<style scoped>
.v-container {
  padding: 0 !important;
}
</style>
